/* ══════════════════════════════════════════════════════════════
   Language Selector — 8-language dropdown with native scripts
   Persists choice to localStorage, triggers locale change
   ══════════════════════════════════════════════════════════════ */

import { SUPPORTED_LOCALES, getLocale, setLocale, type Locale } from '../utils/i18n';

export function renderLanguageSelector(container: HTMLElement): void {
    const current = getLocale();

    const options = SUPPORTED_LOCALES.map(l => `
        <button class="lang-option ${l.code === current ? 'active' : ''}" data-lang="${l.code}">
            <span class="lang-flag">${l.flag}</span>
            <span class="lang-native">${l.nativeName}</span>
            <span class="lang-english">${l.name}</span>
            ${l.code === current ? '<span class="lang-check">✓</span>' : ''}
        </button>
    `).join('');

    container.innerHTML = `
    <div class="glass-card language-selector-panel">
        <div class="card-header">
            <h3>🌐 Language / भाषा</h3>
            <span class="lang-current">${SUPPORTED_LOCALES.find(l => l.code === current)?.nativeName || 'English'}</span>
        </div>
        <p class="lang-desc">Choose your preferred language. UI labels, navigation, and headers will update instantly.</p>
        <div class="lang-grid">
            ${options}
        </div>
        <div class="lang-footer">
            <small>Translations are community-contributed. Financial data remains in English numerals.</small>
        </div>
    </div>`;

    // Bind click handlers
    container.querySelectorAll('.lang-option').forEach(btn => {
        btn.addEventListener('click', () => {
            const lang = (btn as HTMLElement).dataset.lang as Locale;
            if (lang) {
                setLocale(lang);
                // Re-render to update active state
                renderLanguageSelector(container);
            }
        });
    });
}
